import React, { useState, useRef, useEffect } from 'react';
import { Pencil } from 'lucide-react'; // or any icon library you prefer

interface EditableTextProps {
  text: string;
  onChange: (newText: string) => void;
  className?: string;
  placeholder?: string;
  isEditable: boolean;
}

const EditableText: React.FC<EditableTextProps> = ({ text, onChange, className = '', placeholder = '', isEditable = true }) => {
  const [editing, setEditing] = useState(false);
  const [value, setValue] = useState(text ?? '');
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (editing) inputRef.current?.focus();
  }, [editing]);

useEffect(() => {
  setValue(text ?? '');
}, [text]);

  const handleBlur = (e:any) => {
    setEditing(false);
    if(!value){
      setValue(e.target.value);
    }
    onChange(value);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') inputRef.current?.blur();
  };

  return (
    <div className="flex items-center gap-2 group">
      {editing ? (
        // <input
        //   ref={inputRef}
        //   className={`border-none outline-none bg-transparent w-full ${className}`}
        //   value={value}
        //   onChange={(e) => setValue(e.target.value)}
        //   onBlur={handleBlur}
        //   onKeyDown={handleKeyDown}
        //   placeholder={placeholder  ?? ''}
        // />
        <div
        contentEditable
    suppressContentEditableWarning
    className={`${className} border text-white`}
    onBlur={handleBlur}
    onInput={(e) => {
       const html = e.currentTarget.innerHTML;
  const textWithNewlines = html
    .replace(/<div><br><\/div>/g, '\n') // Handle empty divs
    .replace(/<div>/g, '\n')
    .replace(/<\/div>/g, '')
    .replace(/<p>/g, '')
    .replace(/<\/p>/g, '')
    .replace(/<br>/g, '\n'); // Depending on browser
  setValue(textWithNewlines);
  // setValue(e?.currentTarget?.textContent ?? "")
    }
      }
        >
          <p>{text === "" || text === null ? placeholder: text}</p>
        </div>
      ) : (
        <>
          <p className={`${className} whitespace-pre-wrap ${(isEditable && !text) ? "text-white dark:text-white" : ""}`}
          onClick={isEditable ? () => {setEditing(true);} : ()=>{}}>
  {isEditable ? (text || placeholder) : text}
</p>
          {isEditable && <button
            onClick={() => setEditing(true)}
          >
            <Pencil size={16} />
          </button>}
        </>
      )}
    </div>
  );
};

export default EditableText;